var _style, _g, _g2, _path, _path2, _defs, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _defs2, _g4, _defs3, _g5, _path9, _path10, _defs4, _g6, _path11, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnutritionistLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 408.5 390",
    style: {
      enableBackground: "new 0 0 408.5 390"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#29A24D;}\r\n\t.st1{fill:#57B059;}\r\n\t.st2{clip-path:url(#SVGID_2_);}\r\n\t.st3{fill:#81DA80;}\r\n\t.st4{clip-path:url(#SVGID_4_);}\r\n\t.st5{fill:#65BE66;}\r\n\t.st6{clip-path:url(#SVGID_6_);}\r\n\t.st7{fill:#2B8834;}\r\n\t.st8{clip-path:url(#SVGID_8_);}\r\n\t.st9{fill:none;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(175.842834, 275.649973)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.871082, 275.649973)"
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M114.1,237.4c8.4,8.6,16.2,17.9,23.2,27.7c10.3,0.3,20.5,1.3,30.6,2.9c-11.2-16.8-24.2-32.2-38.7-45.9 c9.5-17.7-3.1-45.8-44.3-66.3c-39-19-77.6-11.3-81.3,9.2c-3.9,20.7,19.4,40.6,45,57.4C76.2,240.3,95.7,247.4,114.1,237.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M114.1,231.9c8.4,8.6,16.2,23.4,23.2,33.2c10.3,0.3,20.5,1.3,30.6,2.9c-11.2-16.8-24.2-32.2-38.7-45.9 c9.5-17.7-3.1-45.8-44.3-66.3c-39-19-77.6-11.3-81.3,9.2c-3.9,20.7,19.4,35.1,45,51.8C76.2,234.7,95.7,241.8,114.1,231.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 40.6,
    y: 4.9,
    width: 297.6,
    height: 89.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.2,93.8c19-23.3,44.6-41,73.9-50.1C162.6,31,178.4,22.9,196,22.9c16.8,0,31.9,7.4,42.3,19.1 c24.4,6.5,46.5,18.9,64.6,35.5c11-4.3,22.2-8,33.6-11C302.4,28.7,253.1,5,198.2,5C133.1,5,75.8,38.5,42.4,89.1 C54.8,90.1,66.7,91.7,78.2,93.8z"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M332.4,114.3c3.8,6.5,7.1,13.4,9.9,20.4c9.9-3.6,20-6.8,30.3-9.3c-3.8-9.9-8.3-19.3-13.6-28.3 C349.8,102.2,341,107.9,332.4,114.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M32.1,107.2c-5.1,10-9.3,20.5-12.6,31.5c6.2-2,13.4-3,21.2-3c4.2,0,8.5,0.3,12.8,0.9c2-5.2,4.2-10.2,6.7-15 C51.1,116.2,41.6,111.4,32.1,107.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.8,273.5c-7.6-12.3-13.6-25.7-17.6-40c-1.9-1.1-3.7-2.3-5.7-3.6c-10.8-7-22-15.2-31.1-24.2 c2.1,28.5,10.6,55.1,24,78.6C46.1,280,56.3,276.4,66.8,273.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M282.6,322.9c36.1-12.5,67.9-35.9,91.1-67.6c5.5-15.2,9.1-31.2,10.5-48c-12.4,5.5-24.1,12.1-35.1,19.9 c-9.3,39.8-33.8,73.6-67.1,95L282.6,322.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.1,284c7.8,3.4,15.3,7.2,22.5,11.4c10.3-21.6,23.9-41.6,40.3-59.2c12.9,4.8,30.4,4.8,42.1-4.1 c18.8-16.2,40.8-29.4,65.4-38.4c2.6-0.8,4.2-3.3,3.6-5.6c-0.6-2.4-3.4-3.7-6.1-2.8c-17.8,5.3-34.6,12.7-50.1,21.9 c-2.4,1.4-5.3,0.9-6.6-1.2c-1.3-2.1-0.4-5,2.1-6.5c16.1-9.5,33.6-17.2,52.1-22.7c2.8-0.8,4.6-3.4,4-5.7c-0.6-2.4-3.6-3.6-6.5-2.7 c-19.2,5.7-37.3,13.7-54,23.6c-2.6,1.5-5.7,1.1-7-1s-0.2-5.1,2.5-6.7c17.4-10.2,36.1-18.5,56-24.4c3-0.9,5-3.5,4.4-5.9 s-3.8-3.6-6.9-2.6c-20.6,6.1-40,14.7-58,25.3c-2.8,1.6-6,1.3-7.3-0.8s-0.1-5.2,2.8-6.9c18.6-11,38.7-19.8,59.9-26.1 c3.3-1,5.4-3.6,4.8-6s-3.9-3.5-7.3-2.5c-32.8,8.1-63.5,21.9-90.9,40.5c-16.3,12.3-20,33.3-14.8,46.1 C251.4,239.2,235.5,260.5,223.1,284z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M223.1,284c7.8,3.4,15.3,7.2,22.5,11.4c10.3-21.6,23.9-47.2,40.3-64.8c12.9,4.8,30.4,4.8,42.1-4.1 c18.8-16.2,40.8-23.9,65.4-32.9c2.6-0.8,4.2-3.3,3.6-5.6c-0.6-2.4-3.4-3.7-6.1-2.8c-17.8,5.3-34.6,12.7-50.1,21.9 c-2.4,1.4-5.3,0.9-6.6-1.2c-1.3-2.1-0.4-5,2.1-6.5c16.1-9.5,33.6-17.2,52.1-22.7c2.8-0.8,4.6-3.4,4-5.7c-0.6-2.4-3.6-3.6-6.5-2.7 c-19.2,5.7-37.3,13.7-54,23.6c-2.6,1.5-5.7,1.1-7-1s-0.2-5.1,2.5-6.7c17.4-10.2,36.1-18.5,56-24.4c3-0.9,5-3.5,4.4-5.9 s-3.8-3.6-6.9-2.6c-20.6,6.1-40,14.7-58,25.3c-2.8,1.6-6,1.3-7.3-0.8s-0.1-5.2,2.8-6.9c18.6-11,38.7-19.8,59.9-26.1 c3.3-1,5.4-3.6,4.8-6s-3.9-3.5-7.3-2.5c-32.8,8.1-63.5,21.9-90.9,40.5c-16.3,12.3-20,33.3-14.8,46.1 C251.4,239.2,235.5,260.5,223.1,284z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 33.4,
    y: 65.6,
    width: 376.6,
    height: 213.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M165.8,211.3c11.6,19.2,20.9,39.8,27.7,61.6c4.2,1.2,8.3,2.5,12.4,3.9c7.2-25.9,17.3-50.3,29.9-72.7 C275,134,337.8,83.2,410,65.5c-0.5,0-1,0-1.6,0c-83.2,0-154.5,33.6-210,93.7C147,119.3,96.9,100.6,35.2,96.9 C89.6,120.7,135.3,160.9,165.8,211.3z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 33.4,
    y: 65.6,
    width: 376.6,
    height: 187.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M200.4,250.7C245,134.3,337.8,83.4,410,65.6c-0.5,0-1,0-1.6,0c-83.2,0-154.5,33.6-210,93.7 C147,119.4,96.9,100.7,35.2,97C89.6,120.7,171.4,171.1,200.4,250.7z"
  }))))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M233.9,62c0.5,1.3,1,2.6,1.4,4c0.4,1.3,0.8,2.7,1,4.1c0.3,1.4,0.5,2.8,0.7,4.2c0.1,1.4,0.2,2.8,0.2,4.2 c0,1.4,0,2.8-0.2,4.2c-0.1,1.4-0.3,2.8-0.6,4.2c-0.3,1.4-0.6,2.7-1,4.1c-0.4,1.3-0.9,2.7-1.4,4s-1.1,2.6-1.8,3.8s-1.4,2.5-2.1,3.6 s-1.6,2.3-2.5,3.4c-0.9,1.1-1.8,2.1-2.8,3.1s-2,2-3.1,2.9s-2.2,1.7-3.4,2.5s-2.4,1.5-3.6,2.2c-1.2,0.7-2.5,1.3-3.8,1.8 c-1.3,0.6-2.6,1-3.9,1.5c-1.3,0.4-2.7,0.8-4.1,1.1c-1.4,0.3-2.8,0.5-4.2,0.6s-2.8,0.2-4.2,0.2s-2.8,0-4.2-0.2 c-1.4-0.1-2.8-0.3-4.2-0.6c-1.4-0.3-2.7-0.6-4.1-1s-2.7-0.9-4-1.4s-2.6-1.1-3.8-1.8c-1.2-0.7-2.5-1.4-3.6-2.1s-2.3-1.6-3.4-2.5 s-2.1-1.8-3.1-2.8s-2-2-2.9-3.1s-1.7-2.2-2.5-3.4s-1.5-2.4-2.2-3.6c-0.7-1.2-1.3-2.5-1.8-3.8c-0.6-1.3-1-2.6-1.5-4 c-0.4-1.3-0.8-2.7-1-4.1s-0.5-2.8-0.6-4.2s-0.2-2.8-0.2-4.2c0-1.4,0.1-2.8,0.2-4.2c0.1-1.4,0.3-2.8,0.6-4.2c0.3-1.4,0.6-2.7,1-4.1 c0.4-1.3,0.9-2.7,1.4-4s1.1-2.6,1.8-3.8c0.6-1.2,1.4-2.5,2.1-3.6c0.8-1.2,1.6-2.3,2.5-3.4s1.8-2.1,2.8-3.1s2-2,3.1-2.9 s2.2-1.7,3.4-2.5c1.2-0.8,2.4-1.5,3.6-2.2s2.5-1.3,3.8-1.8c1.3-0.6,2.6-1,4-1.5c1.3-0.4,2.7-0.8,4.1-1c1.4-0.3,2.8-0.5,4.2-0.7 c1.4-0.1,2.8-0.2,4.2-0.2s2.8,0,4.2,0.2c1.4,0.1,2.8,0.3,4.2,0.6c1.4,0.3,2.7,0.6,4.1,1c1.3,0.4,2.7,0.9,4,1.4s2.6,1.1,3.8,1.8 c1.2,0.6,2.4,1.4,3.6,2.1c1.2,0.8,2.3,1.6,3.4,2.5c1.1,0.9,2.1,1.8,3.1,2.8s2,2,2.8,3.1c0.9,1.1,1.7,2.2,2.5,3.4 c0.8,1.2,1.5,2.4,2.2,3.6C232.7,59.4,233.4,60.7,233.9,62z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M194.4,111.2c-22.8,0-41.4-15.6-42.8-35.3c-0.1,0.9-0.1,1.8-0.1,2.8c0,23.7,19.2,42.9,42.9,42.9 s42.9-19.2,42.9-42.9c0-0.9,0-1.9-0.1-2.8C235.8,95.6,217.2,111.2,194.4,111.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 31,
    y: 243.2,
    width: 355.2,
    height: 143.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M207.5,352.6c-39.4,0-76.1-11.4-107-31.2c12.9,4.7,26.6,8.6,40.8,11.5c47.7,9.6,93.7,6.6,131.1-6.3 c-35.7-32.8-86.9-53.4-143.8-53.4c-35.4,0-68.6,8-97.2,21.9c34.6,54.8,95.7,91.3,165.2,91.3c116.8,0,176.1-93.6,187.7-141.4 C361.1,291.1,302.5,352.6,207.5,352.6z"
  }))))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M207.5,352.6c-39.4,0-76.1-11.4-107-31.2c12.9,4.7,26.6,8.6,40.8,11.5c47.7,9.6,93.7,6.6,131.1-6.3 c-35.7-32.8-86.9-53.4-143.8-53.4c-35.4,0-68.6,8-97.2,21.9c34.6,54.8,95.7,78.4,165.2,78.4c116.8,0,176.1-80.7,187.7-128.5 C361.1,291.1,302.5,352.6,207.5,352.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 958.1,
    y: 590.1,
    className: "st9",
    width: 3,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnutritionistLogo);
export default __webpack_public_path__ + "static/media/enutritionistLogo.33220a78f8e9897b3eae825e8789bcb3.svg";
export { ForwardRef as ReactComponent };